import "../../components/MenuShimmerUI/MenuShimmerUI.css";

const MenuShimmerUI = () => {
  return (
    <h1 className="menu-page-load-shimmer">Loading restaurant details ...</h1>
  );
};

export default MenuShimmerUI;
